import { EMAIL_REGEXP } from 'fitify-utils/src/validations'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

import { Button } from 'components/Button/Button'
import { InputField } from 'components/Form/InputField'
import {
  StyledContainer,
  StyledHeading,
  StyledLoginForm,
} from 'components/LoginPage/LoginPage.Styled'
import { useAuthContext } from 'contexts/AuthContext'

type LoginFormValues = {
  email: string
  password: string
}

export default function Page() {
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<LoginFormValues>({ mode: 'onChange' })
  const router = useRouter()

  const { signIn, isAuthLoading, isLoggedIn } = useAuthContext()

  useEffect(() => {
    if (!isAuthLoading && isLoggedIn) {
      router.replace('/campaigns')
    }
  }, [isAuthLoading, isLoggedIn, router])

  const onSubmit = handleSubmit(async (data) => {
    await signIn(data.email, data.password)
  })

  return (
    <StyledContainer>
      <StyledHeading>Fitify EMS</StyledHeading>
      <p>Sign in to your account</p>
      <StyledLoginForm onSubmit={onSubmit}>
        <InputField
          name="email"
          label="Email"
          type="email"
          control={control}
          rules={{
            required: 'Email is required',
            pattern: {
              value: EMAIL_REGEXP,
              message: 'Invalid email address',
            },
          }}
        />
        <InputField
          name="password"
          label="Password"
          type="password"
          control={control}
          rules={{
            required: 'Password is required',
            minLength: {
              value: 6,
              message: 'Password must be at least 6 characters long',
            },
          }}
        />

        <Button type="submit" disabled={!isValid}>
          Sign in
        </Button>
      </StyledLoginForm>
    </StyledContainer>
  )
}
